import { useState, useEffect } from "react";
import FlashCoachLogo from "../../components/_Icons/FlashCoachLogo";
import CompleteIcon from "./icons/success.svg";
import Button from "./../../components/Button";
import { useHistory, useParams } from "react-router-dom";
import styles from "./HelpRequestForm.module.scss";
import ClassNames from "classnames";
import { getLocalValue } from "../../utils/auth";
import { DashboardLayoutWithoutSidebar } from "../../layouts/DashboardLayoutWithoutSidebar";

export const HelpRequestComplete = () => {
  const [accessKey, setAccessKey] = useState("");
  const [employeeId, setEmployeeId] = useState(
    getLocalValue("employee_id") ?? ""
  );

  const history = useHistory();
  const { key } = useParams();

  //check for valid key in url parameter and then only render the page
  useEffect(() => {
    if (sessionStorage.getItem("HRF_EMP_INFO")) {
      const empInfo = JSON.parse(sessionStorage.getItem("HRF_EMP_INFO"));

      if (key !== empInfo.TOKEN.split(".")[0]) {
        history.replace("/");
      } else {
        setAccessKey(key);
      }
    } else {
      const accessToken = getLocalValue("access_token");
      if (accessToken && accessToken !== "") {
        setAccessKey(accessToken.split(".")[0]);
      }
    }
  }, [key, history]);

  return employeeId && employeeId !== "" ? (
    <DashboardLayoutWithoutSidebar>
      <RenderContent akey={accessKey} employeeId={employeeId} />
    </DashboardLayoutWithoutSidebar>
  ) : (
    <div
      className={styles.pageWrapper}
      style={{ height: "100vh", overflow: "hidden" }}
    >
      <div className={styles.topNavbar}>
        <div className={styles.navbarContainer}>
          <div style={{ width: "13%" }}>
            <FlashCoachLogo />
          </div>
        </div>
      </div>
      <RenderContent akey={accessKey} employeeId={employeeId} />
    </div>
  );
};

export const RenderContent = props => {
  const history = useHistory();
  return (
    <div
      className={ClassNames(styles.contentSection, styles.completeRequestPage)}
    >
      <div className={ClassNames(styles.flexCenter)} style={{ width: "50%" }}>
        <img
          src={CompleteIcon}
          alt={"completeIcon"}
          style={{ height: "45%" }}
        />
        <div className={ClassNames(styles.pt20, styles.flexCenter)}>
          <h6 className={styles.formLabel}>
            {"Your help request is on its way"}
          </h6>
          <p className={styles.introText}>
            {
              "We appreciate your patience and if there's anything else you'd like to add, just let us know. Once everything's sorted, tell us your experience in our feedback survey too. Have a great day!"
            }
          </p>
        </div>

        <div className={ClassNames(styles.pt20, styles.flexCenter)}>
          {props.employeeId && props.employeeId !== "" ? (
            <Button
              className={ClassNames(styles.formSubmitButton, styles.width320px)}
              onClick={() => {
                history.replace("/dashboard");
              }}
            >
              {"Back to Dashboard"}
            </Button>
          ) : (
            <Button
              className={ClassNames(styles.formSubmitButton, styles.width320px)}
              onClick={() => {
                sessionStorage.removeItem("HRF_EMP_INFO");
                history.replace("/");
              }}
            >
              {"Back to login"}
            </Button>
          )}
        </div>
        <div className={ClassNames(styles.cancelButton, styles.pt10)}>
          <Button
            type="button"
            onClick={() =>
              props.employeeId && props.employeeId !== ""
                ? history.push(`/help-request/${props.akey}/form`)
                : history.push("/help-request/welcome")
            }
          >
            {"Submit another request"}
          </Button>
        </div>
      </div>
    </div>
  );
};
